import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "../data/content";

const H2 = ({ children }) => (
  <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">{children}</h2>
);

export default function Datenschutz() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <main data-testid="datenschutz-page" className="bg-[#F5F2ED] min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Link to="/" data-testid="datenschutz-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-[#B5651D] hover:text-[#9c5517] transition-colors mb-8">
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-[#1F2933]">Datenschutzerklärung</h1>

        <div className="mt-10 space-y-8 text-[#22282E] leading-relaxed">
          <section>
            <H2>1. Verantwortlicher</H2>
            <p>
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO):<br /><br />
              {COMPANY.name}<br />
              Inhaber: {COMPANY.owner}<br />
              {COMPANY.street}, {COMPANY.city}<br />
              Telefon: {COMPANY.phone}<br />
              E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#B5651D] underline">{COMPANY.email}</a>
            </p>
          </section>

          <section>
            <H2>2. Allgemeine Hinweise zur Datenverarbeitung</H2>
            <p>
              Wir verarbeiten personenbezogene Daten unserer Besucher grundsätzlich
              nur, soweit dies zur Bereitstellung einer funktionsfähigen Website
              sowie unserer Inhalte und Leistungen erforderlich ist. Die
              Verarbeitung erfolgt auf Grundlage der Art. 6 Abs. 1 lit. a, b und f
              DSGVO.
            </p>
          </section>

          <section>
            <H2>3. Zugriffsdaten / Server-Logfiles</H2>
            <p>
              Beim Aufruf dieser Website werden durch den Hosting-Anbieter
              automatisch Informationen in sogenannten Server-Logfiles gespeichert
              (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, Browsertyp).
              Diese Daten dienen der Sicherstellung eines störungsfreien Betriebs
              und werden nicht mit anderen Datenquellen zusammengeführt.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
            </p>
          </section>

          <section>
            <H2>4. Cookies und Einwilligung</H2>
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies
              bzw. lokale Speichereinträge (z. B. zur Speicherung Ihrer
              Cookie-Einstellungen im localStorage Ihres Browsers). Nicht
              notwendige Dienste (z. B. externe Karten oder Statistik-Tools)
              werden erst nach Ihrer ausdrücklichen Einwilligung über den
              Cookie-Banner geladen (Art. 6 Abs. 1 lit. a DSGVO). Ihre Auswahl
              können Sie jederzeit durch Löschen der Browserdaten zurücksetzen.
            </p>
          </section>

          <section>
            <H2>5. Kontaktaufnahme</H2>
            <p>
              Bei der Kontaktaufnahme mit uns (z. B. per Kontaktformular, E-Mail
              oder Telefon) werden die von Ihnen mitgeteilten Daten (Name,
              E-Mail-Adresse, Telefonnummer, Nachricht) zur Bearbeitung Ihrer
              Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Durchführung
              vorvertraglicher Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO.
            </p>
          </section>

          <section>
            <H2>6. Externe Links (Google Maps)</H2>
            <p>
              Diese Website enthält einen Link zu Google Maps zur Anzeige unseres
              Standorts. Beim Anklicken des Links verlassen Sie unsere Website;
              es gelten dann die Datenschutzbestimmungen von Google Ireland
              Limited, Gordon House, Barrow Street, Dublin 4, Irland.
            </p>
          </section>

          <section>
            <H2>7. Ihre Rechte</H2>
            <p>
              Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie
              betreffenden personenbezogenen Daten: Recht auf Auskunft (Art. 15
              DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO),
              Einschränkung der Verarbeitung (Art. 18 DSGVO),
              Datenübertragbarkeit (Art. 20 DSGVO) sowie Widerspruch gegen die
              Verarbeitung (Art. 21 DSGVO). Erteilte Einwilligungen können Sie
              jederzeit mit Wirkung für die Zukunft widerrufen.
            </p>
          </section>

          <section>
            <H2>8. Beschwerderecht bei der Aufsichtsbehörde</H2>
            <p>
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
              beschweren. Zuständig ist: Der Hamburgische Beauftragte für
              Datenschutz und Informationsfreiheit, Ludwig-Erhard-Str. 22, 20459
              Hamburg.
            </p>
          </section>

          <section>
            <H2>9. Speicherdauer</H2>
            <p>
              Personenbezogene Daten werden gelöscht, sobald der Zweck der
              Speicherung entfällt und keine gesetzlichen Aufbewahrungspflichten
              entgegenstehen.
            </p>
          </section>

          <section>
            <H2>10. Aktualität dieser Datenschutzerklärung</H2>
            <p>Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}</p>
          </section>
        </div>
      </div>
    </main>
  );
}
